<template>
  <div>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item has-feedback label="Tên" prop="name">
        <a-select
          placeholder="- Chọn -"
          show-search
          :loading="loadingName"
          option-filter-prop="children"
          :filter-option="filterOption"
          allowClear
          v-model="form.name"
        
        >
          <a-select-option
            v-for="item in modules"
            :key="item"
            :value="item"
            
          >
            {{ item }}
          </a-select-option>
        </a-select>
      </a-form-model-item>

      <a-form-model-item
        has-feedback
        label="Hành động"
        prop="actionsAvailableIds"
      >
        <a-select
          placeholder="- Chọn -"
          show-search
          :loading="loadingPermissionAction"
          option-filter-prop="children"
          :filter-option="filterOption"
          allowClear
            v-model="form.actionsAvailableIds"
            mode="multiple"
        >
          <a-select-option
            v-for="item in permissionActions"
            :key="item.id"
            :value="item.id"
          >
            {{ item.name }}
          </a-select-option>
        </a-select>
      </a-form-model-item>

      <a-form-model-item
        has-feedback
        label="Sở hữu"
        prop="possessionsAvailableIds"
      >
        <a-select
          placeholder="- Chọn -"
          show-search
          :loading="loadingPermissionPossession"
          option-filter-prop="children"
          :filter-option="filterOption"
          allowClear
           v-model="form.possessionsAvailableIds"
            mode="multiple"
        >
          <a-select-option
            v-for="item in permissionPossessions"
            :key="item.id"
            :value="item.id"
          >
            {{ item.name }}
          </a-select-option>
        </a-select>
      </a-form-model-item>

      <a-form-model-item label="Mô tả">
        <a-textarea
          v-model="form.description"
          placeholder="Nhập mô tả...."
          :auto-size="{ minRows: 3 }"
        />
      </a-form-model-item>
    </a-form-model>

    <div
      style="text-align: right;"
      :style="{
        position: 'absolute',
        right: 0,
        bottom: 0,
        width: '100%',
        borderTop: '1px solid #e9e9e9',
        padding: '10px 16px',
        background: '#fff',
        textAlign: 'right',
        zIndex: 1,
      }"
    >
      <a-button @click="closeDrawerAdd" style="margin-right: 5px;" icon="close">
        Đóng
      </a-button>
      <a-button
        type="primary"
        @click="create()"
        :loading="iconLoading"
        icon="plus"
      >
        Thêm mới
      </a-button>
    </div>
  </div>
</template>
<script>
import queryItem from "../data/queryItem";

export default {
  props: {
    closeDrawerAdd: {
      type: Function,
      default: null,
    },
    createdOnView: {
      type: Function,
    },
  },
  data() {
    return {
      loadingName: true,
      loadingPermissionAction: true,
      loadingPermissionPossession: true,

      iconLoading: false,

      modules: [],
      permissionActions: [],
      permissionPossessions: [],
      form: {
        name: undefined,
        description: undefined,
        actionsAvailableIds: [],
        possessionsAvailableIds: [],
      },
      rules: {
        name: [
          {
            required: true,
            message: "Tên không được bỏ trống",
            trigger: "change",
          },
        ],
      },
    };
  },
  methods: {
    getNameModules() {
      this.loadingName = true;
      this.$apollo
        .query({
          fetchPolicy: "no-cache",
          query: queryItem.queryGetListNameModule,
        })
        .then(({ data }) => {
          if (data.getListNameModule) {
            this.modules = [...data.getListNameModule];
          }
          this.loadingName = false;
        })
        .catch(()=> {
           console.log("Không lấy được danh sách", error);
        });
    },
    getPermissionActions() {
      this.loadingPermissionAction = true;
      this.$apollo
        .query({
             fetchPolicy: "no-cache",
          query: queryItem.queryAllPermissionAction,
        })
        .then(({ data }) => {
        
          if (data.getAllPermissionAction) {
            this.permissionActions = [...data.getAllPermissionAction];
          }
          this.loadingPermissionAction = false;
        })
        .catch((error) => {
          console.log("Không lấy được danh sách", error);
        });
    },
    getPermissionPossessions() {
      this.loadingPermissionPossession = true;
      this.$apollo
        .query({
             fetchPolicy: "no-cache",
          query: queryItem.queryGetAllPermissionPossession,
        })
        .then(({ data }) => {
         
    
          if (data.getAllPermissionPossession) {
            this.permissionPossessions = [...data.getAllPermissionPossession];
          
          }
          this.loadingPermissionPossession = false;
        })
        .catch((error) => {
          console.log("Không lấy được danh sách", error);
        });
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    create() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.iconLoading = true;
          console.log(this.form);
          this.$apollo
            .mutate({
              mutation: queryItem.queryCreate,
              variables: {
                ...this.form,
              },
            })
            .then(({ data }) => {
              if (data?.createModule) {
                this.$notification.success({
                  message: "Thông báo",
                  description: "Thêm thành công !",
                });
                this.closeDrawerAdd();
                this.createdOnView(data.createModule);
              }
              this.iconLoading = false;
            })
            .catch((error) => {
              this.$notification.error({
                message: "Thông báo",
                description: "Thêm không thành công, Tên bạn chọn bị trùng",
              });
              this.iconLoading = false;
            });
        }
      });
    },
  },
  created() {
    this.getPermissionActions();
    this.getPermissionPossessions();
    this.getNameModules();
  },
};
</script>
<style></style>
